import { useCallback, useEffect, useState, useMemo } from "react";
import { toEndOfDay, toStartOfDay } from "@common/utils/localTime.utils";
import { getSafeChartData, getStartTime, getStopTime } from "./utils";
import { getGraph } from "@services/monitoring";
import { GraphType, MonitoringGraphData } from "@services/monitoring/types";
import { Device } from "@services/devices/types";

type UseMeetingChartDataParams = {
  device: Device | undefined;
  graphType: GraphType;
  start?: number;
  end?: number;
};

export const useMeetingChartData = (params: UseMeetingChartDataParams) => {
  const {
    device,
    graphType,
    start = toStartOfDay(new Date()).getTime(),
    end = toEndOfDay(new Date()).getTime(),
  } = params;

  const [chartState, setChartState] = useState<MonitoringGraphData[]>([]);

  const stopTime = getStopTime(end);
  const startTime = getStartTime(start, stopTime);

  const updateChartData = useCallback(async () => {
    try {
      const chartData = await getGraph(
        device?.id,
        startTime,
        stopTime,
        graphType,
        false
      );

      const safeChartData = getSafeChartData(chartData);

      setChartState(safeChartData);
    } catch (e) {}
  }, [graphType, startTime, stopTime]);

  return useMemo(
    () => ({
      meetingChartData: chartState,
      startTime,
      stopTime,
      updateChartData,
    }),
    [chartState, startTime, stopTime]
  );
};
